import ApiBase from '../../ApiBase';

class Session extends ApiBase {
    route = '/admin/main-stage/sessions';

    /**
     * @method checkSessionOverlap
     * @param {object} data
     * @return {Promise<boolean|{status: number}>}
     */
    checkSessionOverlap = async (data) => {
        return this.post(this.route + '/check-session-overlap', data);
    };
}

export default new Session();
